<div [id]="modalName" class="uk-modal no-select">
  <div class="uk-modal-dialog uk-modal-dialog-small">
    <a class="uk-modal-close uk-close"></a>
    <ng-content></ng-content>
  </div>
</div>
